import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { logout_Medecin_PS } from "../../actions/userActions";
import { getInfoLab } from "../../actions/labInfo/labInfoActions";
import { MEDECIN_PS_DETAIL_RESET } from "../../constants/user_constant";

import { styled } from "@mui/material/styles";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";

import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";

import { isExpired } from "react-jwt";
// info for munu notifaction
const drawerWidth = 400;
//

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export default function Navbar3({ children }) {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const medecinPSLogin = useSelector((state) => state.medecinPSLogin);
  let { medecinPSInfo } = medecinPSLogin;
  const labInfo = useSelector((state) => state.labInfo);
  let { labInfos } = labInfo;

  // console.log(tokenDecoded)

  const tokenisExpired = isExpired(localStorage.getItem("tokenMPS"));

  useEffect(() => {
    dispatch(getInfoLab());

    if (tokenisExpired === true || !medecinPSInfo) {
      navigate("/loginMedecinPS");
      dispatch({ type: MEDECIN_PS_DETAIL_RESET });
      dispatch(logout_Medecin_PS());
    }
  }, [dispatch, medecinPSInfo, tokenisExpired, navigate]);

  const logout_Medecin_Hundler = () => {
    handleClose();
    navigate("/loginMedecinPS");
    dispatch(logout_Medecin_PS());
  };
  // handel profile menu
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const theme = createTheme({
    typography: {
      fontFamily: ["Montserrat", "Open Sans"].join(","),
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          sx={{ py: -2, maxHeight: 50, bgcolor: "#1976D2" }}
        >
          {" "}
          <Toolbar disableGutters sx={{ px: 5, pb: 2 }}>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="index.html"
                  key="Accueil"
                >
                  <Typography textAlign="center">Accueil</Typography>
                </MenuItem>
                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="razi.html#/patient"
                  key="Espace Patient"
                >
                  <Typography textAlign="center">Espace Patient</Typography>
                </MenuItem>
                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="medecin.html"
                  key="Espace Médecin"
                >
                  <Typography textAlign="center">Espace Médecin</Typography>
                </MenuItem>
                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="partenaire.html"
                  key="Espace Partenaire"
                >
                  <Typography textAlign="center">Espace Partenaire</Typography>
                </MenuItem>
                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="razi.html#/loginMedecinPS"
                  key="Medecin ps"
                >
                  <Typography textAlign="center">
                    Medecin Préscripteur
                  </Typography>
                </MenuItem>

                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="index.html#contact"
                  key="Contact"
                >
                  <Typography textAlign="center">Contact</Typography>
                </MenuItem>
              </Menu>
            </Box>
            <span className="icon is-medium">
              <i className="mdi mdi-24px mdi-flask-outline"></i>
            </span>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
                ml: 2,
              }}
            >
              {labInfos ? labInfos.TITRE_DU_LABORATOIRE : null}
            </Typography>

            <Box
              sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, py: 0 }}
            >
              <Button
                href="index.html"
                key="Accueil"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Accueil
              </Button>
              <Button
                href="razi.html#/patient"
                key="Espace Patient"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Espace Patient
              </Button>
              <Button
                href="medecin.html"
                key="Espace Médecin"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Espace Médecin
              </Button>
              <Button
                href="partenaire.html"
                key="Espace Partenaire"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Espace Partenaire
              </Button>
              <Button
                href="razi.html#/loginMedecinPS"
                key="Medecin ps"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Medecin Préscripteur
              </Button>

              <Button
                href="index.html#contact"
                key="Contact"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Contact
              </Button>
            </Box>
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {medecinPSInfo && (
                  <MenuItem onClick={logout_Medecin_Hundler}>
                    Déconnexion
                  </MenuItem>
                )}
              </Menu>
            </div>
          </Toolbar>
        </AppBar>

        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />
          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
}
